import Api from "../utils/Api";
import { createParams } from "../utils/ProgUtil";
import * as types from "./Types";

export const sendLetterToEveryone = (letterText) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/send_letter_to_everyone?${params}`, {
      letterText,
    });
  };
};

export const getNestLetters = ({ createdSinceDays } = {}) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {
      created_since_days: createdSinceDays,
    });
    return Api.get(`/admin/nest_letters?${params}`);
  };
};

export const draftNestResponse = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/draft_nest_response?${params}`, {
      memberId,
    });
  };
};

export const getMarketingEmailRecipients = () => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/marketing_email_recipients?${params}`);
  };
};

export const importMarketingEmailRecipients = (emailsText) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/import_marketing_email_recipients?${params}`, {
      emailsText,
    });
  };
};

export const sendMarketingEmail = () => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/send_marketing_email?${params}`);
  };
};

export const respondToNestLetter = (
  letterId,
  letterText,
  giftFeathers,
  giftGold,
  giftRunnerId,
  createdSinceDays,
) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {
      created_since_days: createdSinceDays,
    });
    return Api.post(`/admin/respond_to_nest_letter?${params}`, {
      letterId,
      letterText,
      giftFeathers,
      giftGold,
      giftRunnerId,
    });
  };
};

export const sendLetterToMember = (
  memberId,
  letterText,
  giftFeathers,
  giftRunnerId,
) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/send_letter_to_member?${params}`, {
      memberId,
      letterText,
      giftFeathers,
      giftRunnerId,
    });
  };
};

export const markNestLetterRead = (letterId, read, createdSinceDays) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {
      created_since_days: createdSinceDays,
    });
    return Api.post(`/admin/mark_nest_letter_read?${params}`, {
      letterId,
      read,
    });
  };
};

export const getMember = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member/${memberId}?${params}`);
  };
};

export const getMemberLetterHistory = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member_letter_history/${memberId}?${params}`);
  };
};

export const getMemberFriends = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member_friends/${memberId}?${params}`);
  };
};

export const getMemberUnlockAndFeatherHistory = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(
      `/admin/member_unlock_and_feather_history/${memberId}?${params}`,
    );
  };
};

export const getMemberCharacterSummary = (memberId) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/member_character_summary/${memberId}?${params}`);
  };
};
